import { action, makeObservable, observable } from "mobx";
import { AddressClass, AddressModel } from "./address";
import { clientValidators } from "./clientValidators";
import { ValidatedValue } from "./validator";
import Formatter, { CapitalizationType } from "./formatter";


export interface SeniorProposalModel {
  firstName: ValidatedValue<string>;
  lastName: ValidatedValue<string>;
  pesel: ValidatedValue<string>;
  address: AddressModel;

  clearErrorMessages: () => void;
  validate: () => boolean;
}

interface DefaultSeniorArguments {
  firstName?: string;
  lastName?: string;
  pesel?: string;
  address?: AddressModel;
}

export class SeniorProposal implements SeniorProposalModel {
  @observable pesel: ValidatedValue<string> = new ValidatedValue("", [...clientValidators.pesel, ...clientValidators.peselAgeOver60]);
  @observable firstName: ValidatedValue<string> = new ValidatedValue("", clientValidators.firstName);
  @observable lastName: ValidatedValue<string> = new ValidatedValue("", clientValidators.lastName);
  @observable address: AddressModel = AddressClass.default();

  constructor(args?: DefaultSeniorArguments) {
    makeObservable(this);

    this.firstName.value = Formatter.capitalizeWords(args?.firstName, CapitalizationType.full) ?? "";
    this.lastName.value = Formatter.capitalizeWords(args?.lastName, CapitalizationType.full) ?? "";
    this.pesel.value = args?.pesel ?? "";
    this.address = args?.address ?? AddressClass.default();
  }


  @action
  public clearErrorMessages() {
    this.pesel.clearValidation();
    this.firstName.clearValidation();
    this.lastName.clearValidation();
  }

  @action
  public validate() {
    this.firstName.validate();
    this.lastName.validate();
    this.pesel.validate();
    this.address.validate();
    return !!this.firstName.errorMessage || !!this.lastName || !!this.pesel;
  }
}
